import { Injectable } from "@angular/core";

@Injectable()
export class Globals {
  apiUrl: string = "https://api.plemexx.com";
  permisosdisponibles = [
    "DASHBOARD",
    "DESCUENTOS",
    "USUARIOS",
    "VENTAS",
    "CONFIGURACION"
  ];
}
